import {action, observable, runInAction, makeObservable} from 'mobx';
import {decorate, inject, injectable} from '@yosmanyga/di';
import {Translator} from '@yosmanyga/base';

class AppTranslationController {
    loaded: boolean;

    constructor(private translator: Translator) {
        this.loaded = false;

        makeObservable(this, {
            loaded: observable,
            load: action,
        });
    }

    load = async (language: string) => {
        await this.translator.load(language);

        runInAction(() => {
            this.loaded = true;
        });
    };
}

decorate(injectable(), AppTranslationController);
decorate(inject(Translator), AppTranslationController, 0);

export {AppTranslationController};
